import { render, staticRenderFns } from "./AffiliateCoupons.vue?vue&type=template&id=a8d6afa0&scoped=true&"
import script from "./AffiliateCoupons.vue?vue&type=script&lang=js&"
export * from "./AffiliateCoupons.vue?vue&type=script&lang=js&"
import style0 from "./AffiliateCoupons.vue?vue&type=style&index=0&id=a8d6afa0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8d6afa0",
  null
  
)

export default component.exports